import { EmailToSanitize } from "intake_shared/src/types";
import { uniqBy } from "lodash";

export function sanitiseEmailRecipients(email: EmailToSanitize): EmailToSanitize {
    const { recipient, cc } = email;
    if (cc) {
        email.cc = uniqBy(cc, "email");
    } else {
        email.cc = [];
    }
    email.cc = email.cc?.filter((c) => {
        const lowerCc = c.email.toLowerCase();
        const lowerRecipient = recipient.email.toLowerCase();
        return lowerCc.length > 0 && lowerCc !== lowerRecipient && lowerCc !== "n/a";
    });
    return email;
}
